import { ContextAction } from '../types';
import type { ReportRegenerationModalAction } from './types';

export const reportRegenerationModalReducer = (
  state: boolean,
  action: ReportRegenerationModalAction
) => {
  switch (action.type) {
    case ContextAction.setReportRegenerationModal:
      return action.payload ?? false;
    default:
      return state;
  }
};
